import Vue from 'vue'
import App from '@/App'
import store from '@/store/'
import router from '@/router/'
import toast from '@/plugins/toast'
import * as filter from '@/filters/'

import '@/directives/index'

Vue.prototype.$EventBus = new Vue()

// Remove product tips
Vue.config.productionTip = false
Vue.use(toast, {})

Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})

window.app = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
